/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Chip from '@mui/material/Chip';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button, Typography } from '@mui/material';
import useStore from '../../../states/store';
import usePRDcontext from '../context/usePRDcontext';
import { Circle } from '@mui/icons-material';

function Table() {
  const { loading, dashboardData } = useContext(usePRDcontext);
  const auth = useStore((state) => state.auth);
  const watermarkText = `"${`${auth?.first_name} ${auth?.last_name}     `.repeat(100)}"`;

  const legendArr = [
    { color: '#1F4D10', value: 'E(>=120)' },
    { color: '#557c55', value: 'SG(100-119)' },
    { color: '#65B741', value: 'G(90-99)' },
    { color: '#ffff00', value: 'Y(80-89)' },
    { color: '#ff0000', value: 'R(50-79)' },
    { color: '#720000', value: 'SR(<= 50)' },
    { color: '#e6e6e6', value: 'N/A' },
  ];

  const handleCellValue = (value) => {
    let cellValue;

    if (value === null || value === undefined) {
      cellValue = 'N/A';
    } else {
      cellValue = `${value}%`;
    }

    return cellValue;
  };

  const handlePerfCellClassName = (value) => {
    let color;

    if (value >= 120) {
      color = { backgroundColor: '#1F4D10', color: '#fff', fontWeight: 'bold' };
    }

    if (value >= 100 && value <= 119) {
      color = { backgroundColor: '#557c55', color: '#000', fontWeight: 'bold' };
    }

    if (value >= 90 && value <= 99.99) {
      color = { backgroundColor: '#65B741', color: '#000', fontWeight: 'bold' };
    }

    if (value >= 80 && value <= 89.99) {
      color = { backgroundColor: '#ffff00', color: '#000', fontWeight: 'bold' };
    }

    if (value >= 50 && value <= 79.99) {
      color = { backgroundColor: '#ff0000', color: '#fff', fontWeight: 'bold' };
    }

    if (value < 50) {
      color = { backgroundColor: '#720000', color: '#fff', fontWeight: 'bold' };
    }

    if (value === null || value === undefined) {
      color = { backgroundColor: '#e6e6e6', color: '#000', fontWeight: 'bold' };
    }

    return color;
  };

  const columns = [
    {
      field: 'january',
      headerName: 'JAN',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.january)} sx={handlePerfCellClassName(row.january)} />
      ),
    },
    {
      field: 'february',
      headerName: 'FEB',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.february)} sx={handlePerfCellClassName(row.february)} />
      ),
    },
    {
      field: 'march',
      headerName: 'MAR',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.march)} sx={handlePerfCellClassName(row.march)} />
      ),
    },
    {
      field: 'april',
      headerName: 'APR',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.april)} sx={handlePerfCellClassName(row.april)} />
      ),
    },
    {
      field: 'may',
      headerName: 'MAY',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.may)} sx={handlePerfCellClassName(row.may)} />
      ),
    },
    {
      field: 'june',
      headerName: 'JUNE',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.june)} sx={handlePerfCellClassName(row.june)} />
      ),
    },
    {
      field: 'july',
      headerName: 'JUL',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.july)} sx={handlePerfCellClassName(row.july)} />
      ),
    },
    {
      field: 'august',
      headerName: 'AUG',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.august)} sx={handlePerfCellClassName(row.august)} />
      ),
    },
    {
      field: 'september',
      headerName: 'SEP',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.september)} sx={handlePerfCellClassName(row.september)} />
      ),
    },
    {
      field: 'october',
      headerName: 'OCT',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.october)} sx={handlePerfCellClassName(row.october)} />
      ),
    },
    {
      field: 'november',
      headerName: 'NOV',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.november)} sx={handlePerfCellClassName(row.november)} />
      ),
    },
    {
      field: 'december',
      headerName: 'DEC',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.december)} sx={handlePerfCellClassName(row.december)} />
      ),
    },
    {
      field: 'ytd',
      headerName: 'YTD',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={handleCellValue(row.ytd)} sx={handlePerfCellClassName(row.ytd)} />
      ),
    },
    {
      field: 'percent_share',
      headerName: 'SHARE',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip
          label={handleCellValue(row.percent_share)}
          sx={handlePerfCellClassName(row.percent_share)}
        />
      ),
    },
  ];
  const getTreeDataPath = (row) => row.hierarchy;
  const groupingColDef = {
    headerName: '',
    field: 'hierarchy',
    width: 300,
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box
          className='table-container'
          sx={{
            height: '800px',
            marginLeft: '20px',
            position: 'relative',

            '& .super-app-theme--header': {
              backgroundColor: '#169016',
              color: '#fff',
              fontWeight: 'bold',
            },
            '& .row-index--1': { fontWeight: 'bold', backgroundColor: '#cdf8cd' },
            backgroundImage: `
      repeating-linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.05) 0,
        rgba(0, 0, 0, 0.05) 1px,
        transparent 1px,
        transparent 100px
      ),
      repeating-linear-gradient(
        -45deg,
        rgba(0, 0, 0, 0.05) 0,
        rgba(0, 0, 0, 0.05) 1px,
        transparent 1px,
        transparent 100px
      )
    `,
            '&::before': {
              content: `"${auth?.first_name} ${auth?.last_name} ${auth?.first_name} ${auth?.last_name}\\A${auth?.first_name} ${auth?.last_name} ${auth?.first_name} ${auth?.last_name}\\A${auth?.first_name} ${auth?.last_name} ${auth?.first_name} ${auth?.last_name}"`,
              whiteSpace: 'pre',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '150%',
              height: '100%',
              fontSize: '2rem',
              color: 'rgba(0, 0, 0, 0.2)',
              opacity: 0.8,
              transform: 'rotate(-30deg)',
              zIndex: 1,
              pointerEvents: 'none',
              backgroundSize: '200px 200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 7,
            },
            '&::after': {
              content: `"${auth?.first_name} ${auth?.last_name} ${auth?.first_name} ${auth?.last_name}\\A${auth?.first_name} ${auth?.last_name} ${auth?.first_name} ${auth?.last_name}\\A${auth?.first_name} ${auth?.last_name} ${auth?.first_name} ${auth?.last_name}"`,
              whiteSpace: 'pre',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '50%',
              height: '100%',
              fontSize: '2rem',
              color: 'rgba(0, 0, 0, 0.2)',
              opacity: 0.8,
              transform: 'rotate(-30deg)',
              zIndex: 1,
              pointerEvents: 'none',
              backgroundSize: '200px 200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 7,
            },
          }}
        >
          <Grid container pb={2}>
            <Grid item md={2}>
              <Typography
                variant='subtitle2'
                mt={1}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '18px',
                  fontWeight: '3px',
                }}
              >
                Legend:
              </Typography>
            </Grid>
            {legendArr?.map((row) => (
              <Grid item md={1}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textTransform: 'none',
                  }}
                >
                  <Circle fontSize='small' sx={{ color: row?.color }} />
                  <Typography variant='body2' sx={{ fontSize: '15px' }}>
                    {row?.value}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          <DataGridPro
            treeData
            loading={loading}
            rows={dashboardData}
            columns={columns}
            getTreeDataPath={getTreeDataPath}
            groupingColDef={groupingColDef}
            defaultGroupingExpansionDepth={-1}
            getRowClassName={(params) => `row-index--${params.row.id}`}
            sx={{
              position: 'relative',
              zIndex: 2,
              '& .row-index--1:hover': {
                backgroundColor: '#cdf8cd',
              },
              '& .row-index--1.Mui-hovered': {
                backgroundColor: '#cdf8cd',
              },
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default Table;
